
const PlaceCategories = {
	BUSINESS: "business",
	PHARMACY: "pharmacy",
	ACCOMMODATION: "accommodation",
	CULTURE: "culture",
	INSTITUTION: "institution",
	OPEN_AIR: "open_air",
}

class PlaceCategory {

	constructor(jsonData) {
		if (!jsonData)
			jsonData = {};

		this.id = jsonData.id;
		this.name = jsonData.name;
		this.descriptor = jsonData.descriptor;
		this.parentId = jsonData.parentId;
		this.iconId = jsonData.iconId;
		this.iconData = null

		this.childs = [];
		if (jsonData.childs) {

			for (var index = 0; index < jsonData.childs.length; index++) {
				this.addChild(new PlaceCategory(jsonData.childs[index]));
			}
		}

	}

	copySimple(jsonData) {
		if (!jsonData)
			jsonData = {};

		this.id = jsonData.id;
		this.name = jsonData.name;
		this.descriptor = jsonData.descriptor;
		this.parentId = jsonData.parentId;
		this.iconId = jsonData.iconId;
	}
	
	isValid() {
		return this.name && this.descriptor && (this.iconData || this.iconId);
	}

	addChild(placeCategory) {
		this.childs.push(placeCategory);
	}

	all() {
		let all = [this];
		for (var index = 0; index < this.childs.length; index++) {
			Array.prototype.push.apply(all, this.childs[index].all());
		}
		return all;
	}


}


export { PlaceCategory, PlaceCategories };